import { useDispatch } from "react-redux";
import { documents } from "./documents";
import { setDocuments } from "../../../../entities/patient-stats/documents/documents.slice";

export const useGetDocuments = () => {
  const dispatch = useDispatch();

  const getDocumentsByPatientId = async (patientId: string) => {
    const res = await new Promise((resolve) => {
      setTimeout(() => {
        const filtered = documents.filter(
          (p) => String(p.patientId) === patientId,
        );
        resolve(filtered[0] ?? documents[0]);
      }, 400);
    }); // имитация API

    dispatch(setDocuments(res)); // сохраняем в сторе
  };

  return {
    getDocumentsByPatientId,
  };
};
